export const contractTemplate = {
  clauses: {
    object: `1 - DO OBJETO DO PRESENTE CONTRATO

1.1 A CONTRATADA compromete-se a prestar os serviços de instalação do sistema fotovoltaico, bem como tratativas com a concessionária de distribuição de energia elétrica.

Parágrafo 1º: A CONTRATADA poderá, caso necessário, substituir marcas, modelos ou potências dos equipamentos especificados (como módulos, inversores e demais componentes), desde que os itens substituídos possuam qualidade técnica equivalente ou superior. Tal substituição poderá ocorrer por motivos como indisponibilidade em estoque, descontinuidade do fornecedor ou necessidade de manutenção do cronograma da obra.`,

    price: `2 - PREÇO E FORMA DE PAGAMENTO

2.1 O CONTRATANTE pagará à CONTRATADA, pelos serviços descritos na cláusula primeira deste compromisso, a quantia especificada neste contrato, que inclui materiais, mão de obra, engenharia, serviços de projetos e aprovações.

2.2 Fica acordado o pagamento nas seguintes condições:
Pagamento único no valor informado na cláusula 2.1, a serem pagos pela CONTRATANTE à CONTRATADA mediante TRANSFERÊNCIA BANCÁRIA.

2.3 O não cumprimento pelo CONTRATANTE das datas e prazos avençados nesta cláusula o constituirá em mora, independentemente de interpelação da CONTRATADA, nos termos do artigo 397 do Código Civil. Ainda, acarretará à CONTRATADA multa equivalente a 2% do valor total, acrescidos de juros de mora de 3% ao mês, contados a partir do inadimplemento da obrigação.

2.4 Quaisquer valores, custos, ou acréscimos que surjam em decorrência de alteração de alíquota, ou dos prazos de boletos, ou mesmo de renegociações, serão de responsabilidade do CONTRATANTE.`,

    contractorDuties: `3 - DOS DEVERES E OBRIGAÇÕES DA CONTRATADA

A CONTRATADA obriga-se a:

3.1 Protocolar o projeto em até 15 (quinze) dias úteis, mediante a entrega da documentação preliminar devidamente assinada pelo CONTRATANTE.

3.2 Iniciar a instalação em até 15 (quinze) dias úteis, contados a partir da chegada de todo o material.

3.3 Instruir, à distância, o CONTRATANTE ou alguém por ele indicado, sobre como realizar a primeira configuração do monitoramento do inversor. Caso este venha a sofrer alguma falha e seja necessário utilizar deste serviço, o CONTRATANTE deverá arcar com as despesas pelo serviço prestado pela CONTRATADA.

3.4 Mandar, uma só vez, o formulário à concessionária de energia solicitando alteração no envio de créditos de energia para outras unidades sem ônus para o CONTRATANTE. Caso deseje novos envios, deverá arcar com as despesas para tal.

3.5 Fornecer mão de obra devidamente qualificada e equipamentos de proteção individual (EPI).

3.6 Solicitar a troca do medidor de energia elétrica realizada pela concessionária de energia.`,

    clientDuties: `4 - DOS DEVERES E OBRIGAÇÕES DO CONTRATANTE

O CONTRATANTE obriga-se a:

4.1 Efetuar o pagamento do preço do serviço, na forma e prazo combinados;

4.2 Efetuar o pagamento do valor de deslocamento da equipe da CONTRATADA que for acionada para reconfigurar o monitoramento do inversor;

4.3 Disponibilizar serviços de internet necessários para o monitoramento do sistema no local onde será instalado o inversor;

4.4 Permitir livre acesso ao local de instalação, quando solicitado;

4.5 Estar com as instalações de acordo com a Norma Brasileira NBR 5410;

4.6 Disponibilizar área mínima de 60m² necessária para instalação do projeto;

4.7 Realizar a manutenção preventiva do sistema fotovoltaico, incluindo a limpeza dos módulos a cada 6 (seis) meses e, pelo menos uma vez a cada 12 (doze) a 24 (vinte e quatro) meses, a verificação técnica dos componentes do sistema, como bornes dos disjuntores, grampos de fixação da estrutura, aterramento e conexões elétricas em geral, a fim de assegurar o desempenho, a segurança e a durabilidade da instalação;

4.8 Para clientes rurais ou optantes por auto leitura, realizá-la conforme datas da concessionária. A CONTRATADA não se responsabiliza por custos devido à falta de envio;

4.9 Acompanhar semanalmente a geração de energia e comunicar dúvidas à CONTRATADA;

4.10 Realizar adequações no padrão elétrico, caso necessário;

4.11 Em locais sem internet ou com inversores desconectados, o CONTRATANTE assume o risco de não identificar falhas de geração ou perdas de eficiência em tempo hábil, não podendo imputar tais prejuízos à CONTRATADA, incluindo possíveis impactos sobre garantias ou perdas operacionais decorrentes da ausência de monitoramento contínuo do sistema;

4.12 Conforme a Lei 14.300/22, a cobrança do FIO B será feita de forma gradual: 15% (2023), 30% (2024), até 100% (2029). Mesmo sem aumento no consumo, a fatura aumentará;

4.13 Em caso de inadimplência, a CONTRATADA poderá interromper a produção de energia remotamente, restabelecendo-a apenas após a quitação da dívida.`,

    deadlines: `5 - PRAZOS E CRONOGRAMA

5.1 O cronograma será avaliado conforme liberação das atividades. Prevê-se 50 dias corridos após pagamento dos materiais para conclusão da obra.

5.2 Atrasos causados por entrega de materiais, condições climáticas ou prazos da concessionária não implicarão em indenização.

5.3 O prazo de homologação depende exclusivamente da concessionária. A CONTRATADA solicitará a vistoria e troca de medidor após instalação.`,

    termination: `6 - DA RESCISÃO E DAS PENALIDADES CONTRATUAIS

6.1 O descumprimento das obrigações por parte do CONTRATANTE permite à CONTRATADA rescindir este contrato sem necessidade de ação judicial;

6.2 O CONTRATANTE também poderá rescindir em caso de descumprimento por parte da CONTRATADA;

6.3 A parte que der causa à rescisão pagará 10% do valor total à outra parte;

6.4 Este contrato é título executivo extrajudicial, conforme artigo 784, III do Código de Processo Civil;

6.5 É celebrado de forma irrevogável e irretratável;

6.6 Se alguma cláusula for considerada inválida, as demais permanecem válidas;

6.7 Toda comunicação será feita por escrito, pessoalmente ou por meios eletrônicos;

6.8 Fica eleito o foro da Comarca de Bataguassu - MS.`,

    warranties: `7 - DAS GARANTIAS

7.1 Os módulos solares e inversores possuem garantia EXCLUSIVAMENTE fornecida pelos seus respectivos fabricantes, nas seguintes condições:

a) Módulos solares:
   - 12 (doze) anos contra defeitos de fabricação
   - 25 (vinte e cinco) anos contra perda de eficiência energética

b) Inversores:
   - 10 (dez) anos contra defeitos de fabricação e perda de eficiência energética

7.2 A CONTRATADA não assume qualquer responsabilidade direta por tais garantias, sendo de sua competência, quando solicitado, prestar suporte ao CONTRATANTE no processo de acionamento da garantia junto aos fabricantes, o que poderá incluir:

Levantamento técnico no local da instalação;

Organização e envio de documentos exigidos pelo fabricante;

Elaboração ou atualização de projetos;

Acompanhamento do processo de análise e eventual substituição dos equipamentos.

7.3 O suporte mencionado na cláusula 7.2 não está incluso no valor deste contrato, podendo a CONTRATADA cobrar honorários adicionais previamente acordados entre as partes para a realização dos serviços necessários ao acionamento da garantia.

7.4 A CONTRATADA oferece garantia de 1 (um) ano exclusivamente sobre os serviços de instalação. Durante este período, se houver desvio superior a 10% na geração de energia estimada, será feita visita técnica para diagnóstico e eventual correção. Esta garantia inclui:

a) Visitas técnicas, diagnósticos e manutenções corretivas de falhas causadas por erro de instalação;
b) Relatórios das três primeiras faturas com créditos de energia, mediante envio da fatura ao suporte da CONTRATADA.

Parágrafo 1º - As garantias dos equipamentos cobrem exclusivamente vícios de fabricação, devendo qualquer acionamento ser feito diretamente aos fabricantes;

Parágrafo 2º - Reparos estruturais devem ser comunicados ao fabricante do equipamento;

Parágrafo 3º - A CONTRATADA não se responsabiliza por danos causados por uso incorreto, falta de monitoramento ou eventos de força maior;

Parágrafo 4º - Alterações ou violações nos equipamentos anulam suas respectivas garantias de fábrica, mesmo dentro do prazo.`,

    liabilityOnTariffs: `8 - DA LIMITAÇÃO DE RESPONSABILIDADE SOBRE TARIFAS E REGULAMENTOS

8.1 A CONTRATADA não se responsabiliza por alterações futuras na legislação do setor elétrico, tributos, taxas, tarifas, e qualquer outro encargo que venha a ser instituído ou modificado por leis, decretos, resoluções e normas editadas pelos órgãos competentes.

8.2 O CONTRATANTE reconhece que a estimativa de economia na fatura de energia elétrica é calculada com base em dados vigentes à época da contratação, não constituindo garantia de redução total ou permanente, pois o resultado depende de fatores como reajustes tarifários, cobrança gradativa do Fio B nos termos da Lei nº 14.300/22, variações climáticas e alterações no padrão de consumo.

8.3 Quaisquer custos adicionais, taxas e encargos eventualmente cobrados pela concessionária ou por outros órgãos reguladores ficarão a cargo do CONTRATANTE, não podendo este imputar responsabilidade ou ônus à CONTRATADA em razão de tais cobranças.`,

    consumptionProfile: `9 - DA ALTERAÇÃO DE PERFIL DE CONSUMO E DIMENSIONAMENTO DO SISTEMA

9.1 O dimensionamento do sistema fotovoltaico é efetuado com base em histórico de consumo fornecido pelo CONTRATANTE. Qualquer mudança substancial no perfil de consumo (aquisição de novos equipamentos de alto consumo, reforma que aumente a carga, etc.) poderá demandar redimensionamento do sistema, não estando inclusa no presente contrato.

9.2 A CONTRATADA não poderá ser responsabilizada por aumento de fatura decorrente de acréscimo de consumo, devendo as partes firmar novo acordo caso se deseje expandir ou adaptar o sistema para a nova demanda.`,

    finalProvisions: `10 - DISPOSIÇÕES FINAIS

10.1 O CONTRATANTE autoriza a divulgação de sua imagem, nome e logotipo pela CONTRATADA em portfólios, redes sociais, materiais impressos e digitais;

10.2 Serviços não especificados neste contrato serão cobrados separadamente, mediante acordo formal entre as partes;

E por estarem de pleno acordo, firmam o presente em duas vias de igual teor e forma.`
  }
};